module.exports = __webpack_public_path__ + "static/media/loc6_img6.2832e8c7.jpg";